import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import emailjs from "emailjs-com"; // Install via `npm install emailjs-com`
import { PencilSquareIcon } from "@heroicons/react/24/solid";

const admissionSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phone: yup
    .string()
    .matches(/^\d{10}$/, "Phone must be a 10-digit number")
    .required("Phone is required"),
  course: yup.string().required("Course is required"),
  message: yup.string().optional(),
});

export const AdmissionForm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(admissionSchema),
  });

  const onSubmit = (data) => {
    const emailData = {
      to_name: "SK Academy",
      from_name: data.name,
      from_email: data.email,
      message: `
        <table border="1" cellpadding="5" cellspacing="0">
          <tr><th>Name</th><td>${data.name}</td></tr>
          <tr><th>Email</th><td>${data.email}</td></tr>
          <tr><th>Phone</th><td>${data.phone}</td></tr>
         
          <tr><th>Message</th><td>${data.message}</td></tr>
        </table>
      `,
    };

    emailjs
      .send(
        "YOUR_SERVICE_ID", // Replace with your EmailJS Service ID
        "YOUR_TEMPLATE_ID", // Replace with your EmailJS Template ID
        emailData,
        "YOUR_PUBLIC_KEY" // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          alert("Form submitted successfully!");
          reset();
          setIsOpen(false);
        },
        () => {
          alert("Failed to send the form. Please try again later.");
        }
      );
  };

  return (
    <div>
      {/* Admission Form Button */}

      <button
        className="flex items-center space-x-2"
        onClick={() => setIsOpen(true)}
      >
        <PencilSquareIcon className="size-8 text-[#556d89]" />
        <span className="text-sm text-[#556d89]">Admission Form</span>
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Admission Form
            </h2>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              {/* Name */}
              <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <input
                      type="text"
                      className={`w-full px-3 py-2 border rounded ${
                        errors.name ? "border-red-500" : "border-gray-300"
                      }`}
                      {...field}
                    />
                  )}
                />
                {errors.name && (
                  <span className="text-red-500 text-sm">
                    {errors.name.message}
                  </span>
                )}
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <input
                      type="email"
                      className={`w-full px-3 py-2 border rounded ${
                        errors.email ? "border-red-500" : "border-gray-300"
                      }`}
                      {...field}
                    />
                  )}
                />
                {errors.email && (
                  <span className="text-red-500 text-sm">
                    {errors.email.message}
                  </span>
                )}
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-medium mb-1">Phone</label>
                <Controller
                  name="phone"
                  control={control}
                  render={({ field }) => (
                    <input
                      type="text"
                      className={`w-full px-3 py-2 border rounded ${
                        errors.phone ? "border-red-500" : "border-gray-300"
                      }`}
                      {...field}
                    />
                  )}
                />
                {errors.phone && (
                  <span className="text-red-500 text-sm">
                    {errors.phone.message}
                  </span>
                )}
              </div>

              {/* Message */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Message
                </label>
                <Controller
                  name="message"
                  control={control}
                  render={({ field }) => (
                    <textarea
                      className="w-full px-3 py-2 border rounded"
                      rows="3"
                      {...field}
                    />
                  )}
                />
              </div>

              {/* Actions */}
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                  onClick={() => setIsOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
